export default __webpack_public_path__ + "1521e7ebf34990f4d270d6d00e506be9.svg";